export default Object.freeze({
  MULTIHOUSING: '10',
  RETAIL: '20',
  INDUSTRIAL: '30',
  OFFICE: '40',
  SPECIAL: '50',
  LAND: '60',
  RESIDENTIAL: '70',
  HOSPITALITY: '80',
  HEALTHCARE: '90',
});
